import { cn } from "@/lib/utils";

interface StatsCardProps {
  title: string;
  value: string | number;
  className?: string;
  loading?: boolean;
}

export const StatsCard = ({
  title,
  value,
  className,
  loading,
}: StatsCardProps) => {
  return (
    <div
      className={cn(
        "rounded-lg border border-border bg-card p-4 shadow-sm transition-shadow hover:shadow-md md:p-6",
        loading && "animate-pulse",
        className
      )}
    >
      <p className="mb-2 text-sm text-muted-foreground">{title}</p>
      {loading ? (
        <div
          className="h-9 w-24 rounded-md bg-muted sm:h-10 sm:w-28"
          aria-hidden
        />
      ) : (
        <p className="text-2xl font-bold tabular-nums tracking-tight text-foreground md:text-3xl">
          {value}
        </p>
      )}
    </div>
  );
};
